/**
 * Is the spin button (or space) HELD for a turbo run right now?
 *
 * Mirrors ReelControlContext's spacebarTurboActive for code outside the
 * context — the landing hooks (ported from Catch the Cod, 2026-10-28: a held
 * run spins straight on, so its symbols land as pictures; only a single press,
 * or the spin after the hold is let go, lands them on their `static` spines).
 */
let held = false;

// ── The moment it is LET GO (2026-10-29) ── the board the held run left
// behind can still be pictures (Games/Shared/turboRest). One listener per
// ROOM ("base", "freeSpins"): the landing hook runs in the reel set and in
// every reel, so each room settles once, by whichever instance is mounted.
const releaseListeners = new Map();

/** fn() when a hold is let go, for `room`. Returns the unsubscribe. */
export const onSpinHoldRelease = (room, fn) => {
  if (!releaseListeners.has(room)) releaseListeners.set(room, new Set());
  releaseListeners.get(room).add(fn);
  return () => releaseListeners.get(room)?.delete(fn);
};

export const setSpinHeld = (value) => {
  // held = !!value;
  const wasHeld = held;
  held = !!value;
  if (wasHeld && !held) {
    releaseListeners.forEach((fns) => {
      const first = fns.values().next().value;
      try {
        first?.();
      } catch {
        // A rest pass never breaks the release itself.
      }
    });
  }
};

export const isSpinHeld = () => held;
